import $ from 'jquery';
import { Swiper, EffectFade, Navigation } from 'swiper';

$(window).on('load', () => {
  $('.carousel__preview').remove();
  const carouselEl = document.querySelectorAll('.carousel');

  function refreshTabindex() {
    const disabledLinks = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-active) a, .swiper-slide:not(.swiper-slide-active) button');
    disabledLinks.forEach((link) => {
      link.tabIndex = -1;
    });

    const activeLinks = this.el.querySelectorAll('.swiper-slide-active a, .swiper-slide-active button');
    activeLinks.forEach((link) => {
      link.tabIndex = 0;
    });
  }

  function updateActiveTabsClasses(carousel) {
    const mainCarousel = carousel.el.closest('.carousel');
    const generatedTabs = mainCarousel.querySelectorAll('.carousel__tab');
    generatedTabs.forEach((el) => el.classList.remove('active'));

    const currentSlideTab = $(carousel.el).find(`.carousel__tab[data-index="${carousel.realIndex}"]`);
    currentSlideTab.addClass('active');
  }
  function carouselNavigation(carousel, controls) {
    controls.forEach((btn) => {
      btn.addEventListener('click', () => {
        const totalSlides = carousel.slides.length;
        const activeSlideIndex = carousel.activeIndex;

        if (btn.className.includes('carousel__nav--prev')) {
          if (activeSlideIndex === 0) {
            carousel.slideTo(totalSlides - 1);
          } else {
            carousel.slidePrev();
          }
        } else {
          if (activeSlideIndex === totalSlides - 1) {
            carousel.slideTo(0);
          } else {
            carousel.slideNext();
          }
        }

        updateActiveTabsClasses(carousel);
      });
    });
  }

  carouselEl.forEach((block) => {
    const prevBtnClass = '.carousel__nav--prev';
    const nextBtnClass = '.carousel__nav--next';
    const slider = block.querySelector('.carousel__swiper-container');

    const nextBtns = block.querySelectorAll(nextBtnClass);
    const prevBtns = block.querySelectorAll(prevBtnClass);

    const carouselParent = $(slider).closest('.carousel');

    const tabs = carouselParent.find('.carousel__category');
    const carouselTabs = carouselParent.find('.carousel__tabs');

    const carousel = new Swiper(slider, {
      modules: [Navigation, EffectFade],
      speed: 200,
      effect: 'fade',
      slidesPerView: 1,
      spaceBetween: 0,
      preloadImages: true,
      breakpoints: {
        992: {
          touchEventsTarget: 'wrapper',
          touchRatio: 0,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
        },
      },
      on: {
        init() {
          refreshTabindex.call(this);
        },
        slideChange() {
          updateActiveTabsClasses(carousel);
        },
        slideChangeTransitionEnd() {
          refreshTabindex.call(carousel);
        },
      },
    });

    function debounce(func, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }

    function handleClick() {
      const generatedTabs = $(block).find('.carousel__tab');
      generatedTabs.removeClass('active');
      generatedTabs.attr('disabled', true);
      const currentIndex = $(this).data('index');
      carousel.slideTo(currentIndex);

      const activeSlide = carousel.slides[currentIndex];
      const currentSlideTab = $(activeSlide).find(`.carousel__tab[data-index="${currentIndex}"]`);
      currentSlideTab.addClass('active');
      generatedTabs.attr('disabled', false);
    }

    carouselTabs.text('');
    for (let i = 0; i < tabs.length; i++) {
      const newTab = `<button class="carousel__tab" data-index="${i}" tabindex="-1">${tabs[i].textContent}</button>`;
      carouselTabs.append(newTab);
    }

    carouselParent.find('.swiper-slide-active .carousel__tabs button').attr('tabindex', 0);

    const desktopTabs = carouselParent.find('.carousel__tab');
    desktopTabs.first().addClass('active');
    carouselNavigation(carousel, nextBtns);
    carouselNavigation(carousel, prevBtns);

    desktopTabs.on('click', debounce(handleClick, 500));
  });
});
